<ra-modal
    [title]="(isEdit() ? 'document.edit.quote.itemModal.titleEdit' : 'document.edit.quote.itemModal.titleNew') | translate"
    [size]="'medium'"
    [disabled]="loading()"
    (close)="close.emit()">

    <div class="item-body" [formGroup]="form">
        <!-- Nome -->
        <ra-input
            formControlName="name"
            [label]="'document.edit.quote.itemModal.name' | translate"
            [placeholder]="'document.edit.quote.itemModal.namePlaceholder' | translate"
        />

        <!-- Tipo (duas opções fixas: segmentado, sem dropdown) -->
        <div class="item-field">
            <span class="item-field-label">{{ 'document.edit.quote.itemModal.type' | translate }}</span>
            <ra-segmented [options]="typeOptions" [formControl]="form.controls.type" />
        </div>

        <!-- Unidade de medida (desabilitada no modo editar) -->
        <div class="item-field">
            <span class="item-field-label">{{ 'document.edit.quote.itemModal.unit' | translate }}</span>
            <ra-select [model]="unitSelectModel" (selectedOption)="onUnitSelect($event)" />
        </div>

        <!-- Quantidade + Preço unitário -->
        <div class="item-row">
            <ra-input
                class="item-row-col"
                formControlName="quantity"
                [type]="'number'"
                [locale]="locale()"
                [label]="'document.edit.quote.itemModal.quantity' | translate"
            />
            <ra-input
                class="item-row-col"
                formControlName="unitPrice"
                [type]="'currency'"
                [currencyCode]="currencyCode()"
                [locale]="locale()"
                [label]="'document.edit.quote.itemModal.unitPrice' | translate"
            />
        </div>

        <!-- Subtotal -->
        <div class="item-subtotal">
            <span class="item-subtotal-label">{{ 'document.edit.quote.itemModal.subtotal' | translate }}</span>
            <span class="item-subtotal-value">{{ subtotal | raCurrency: currencyCode() : locale() }}</span>
        </div>

        <!-- Salvar no catálogo (só no modo criar) -->
        @if (!isEdit()) {
            <div class="item-catalog-row">
                <span class="item-catalog-label">{{ 'document.edit.quote.itemModal.saveInCatalog' | translate }}</span>
                <ra-switch [formControl]="form.controls.saveInCatalog" />
            </div>
        }
    </div>

    <!-- Footer fixo -->
    <div class="item-actions">
        <ra-button
            [label]="'common.cancel' | translate"
            [type]="'primary-outline'"
            [disabled]="loading()"
            (click)="close.emit()"
        />
        <ra-button
            [label]="'common.save' | translate"
            [type]="'primary'"
            [loading]="loading()"
            [disabled]="loading() || form.invalid"
            (click)="onSave()"
        />
    </div>
</ra-modal>
